import React from "react";

import SubscriptionFilters from "./SubscriptionFilters";
import SubscriptionsDesktopTable from "./SubscriptionsDesktopTable";
import SubscriptionsMobileList from "./SubscriptionsMobileList";

import SubscriptionPagination from "../ui/SubscriptionPagination";

export default function SubscriptionsListSection({
  filters,
  isLoading = false,
  deletingId = null,
  onEdit,
  onDelete,
}) {
  return (
    <section className="space-y-4">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-indigo-500">
          Gestion
        </p>

        <h2 className="mt-1 text-xl font-black text-slate-950 dark:text-white">
          Tous les abonnements et prestations
        </h2>

        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Recherche, filtre et gère toutes les
          ventes depuis une liste unique.
        </p>
      </div>

      <SubscriptionFilters filters={filters} />

      <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <SubscriptionsDesktopTable
          subscriptions={
            filters.paginatedSubscriptions
          }
          isLoading={isLoading}
          deletingId={deletingId}
          onEdit={onEdit}
          onDelete={onDelete}
        />

        <SubscriptionsMobileList
          subscriptions={
            filters.paginatedSubscriptions
          }
          isLoading={isLoading}
          deletingId={deletingId}
          onEdit={onEdit}
          onDelete={onDelete}
        />

        {!isLoading && (
          <SubscriptionPagination
            page={filters.page}
            setPage={filters.setPage}
            pageSize={filters.pageSize}
            setPageSize={filters.setPageSize}
            totalItems={filters.totalItems}
            totalPages={filters.totalPages}
            firstVisibleItem={
              filters.firstVisibleItem
            }
            lastVisibleItem={
              filters.lastVisibleItem
            }
          />
        )}
      </div>
    </section>
  );
}